import { atom } from 'nanostores';
export const nav = atom("none");